
import { defineComponent } from "vue";

import { Device, DeviceInfo } from "@capacitor/device";

export default defineComponent({
  name: "Waves",
  props: {
    isNativePlatform: Boolean,
  },
  data: function () {
    return {
      link: "swimstats.net",
      deviceInfo: (null as unknown) as DeviceInfo,
    };
  },
  methods: {},
  created() {
    Device.getInfo().then((deviceInfo) => {
      this.deviceInfo = deviceInfo;
      if (["ios", "mac"].includes(deviceInfo.operatingSystem)) {
        this.link = "https://apps.apple.com/ch/app/swimstats-live/id1618663548";
      } else {
        this.link =
          "https://play.google.com/store/apps/details?id=livelight.swimstats.net";
      }
    });
  },
});
